import React from 'react';
import * as Styles from './NewMacroStep5.style';
import { StepLabel } from 'components/step-label/StepLabel';
import Input from 'components/input';
import { useEditor, Editable } from '@wysimark/react';
import CustomButton from 'components/common/custom-button/custom-button';
import { Message } from 'components/alert/Message';
import { scrollToSection } from 'utils';
import FormikErrorMessage from 'components/formik-error-message/FormikErrorMessage';

const NewMacroStep5 = ({ formikProp, loadingCreateMacro, edited = false, editor }) => {
  const { values, handleChange, errors, touched, handleBlur, setFieldValue, handleSubmit, validateForm } = formikProp;
  const editedTicketEditor = useEditor({ initialMarkdown: edited ? values.message : '', minHeight: 480 });

  return (
    <Styles.NewMacroStep4SC>
      <StepLabel id="ST5" stepCount={'Step 5'}>
        {edited ? `Edit the content for this macro` : `Content for this macro`}
      </StepLabel>
      <Styles.StepDescription>
        The subject line will be used only when this macro is used to begin a new communication thread with a client.
        When replying with a macro to a message from a client, the subject line is not used.
      </Styles.StepDescription>
      <Styles.SubmitReply>
        <Input
          name={'subject'}
          value={values['subject']}
          placeholder={'Subject'}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors['subject']}
          touched={touched['subject']}
        />
        <FormikErrorMessage formikProp={formikProp} value="message" />
        <div style={{ width: '100%' }}>
          {edited ? (
            <Editable
              value={values.message}
              onChange={() => setFieldValue('message', editedTicketEditor.getMarkdown())}
              editor={editedTicketEditor}
            />
          ) : (
            <Editable
              value={values.message}
              onChange={() => setFieldValue('message', editor.getMarkdown())}
              editor={editor}
            />
          )}
        </div>
        <CustomButton
          type="Submit"
          onClick={async () => {
            const errors = await validateForm();
            handleSubmit();
            if (errors.language) {
              Message.error();
              return scrollToSection('ST1');
            }
            if (errors.department) {
              Message.error();
              return scrollToSection('ST2');
            }
            if (errors.label) {
              Message.error();
              return scrollToSection('ST3');
            }
            if (errors.keywords) {
              Message.error();
              return scrollToSection('ST4');
            }
            if (errors.message) {
              Message.error();
              return scrollToSection('ST5');
            }
            if (errors.subject) {
              Message.error();
              return scrollToSection('ST5');
            }
          }}
          title={edited ? `Submit this change for approval` : 'submit for approval'}
          buttonStyles={{ float: 'right', marginTop: '2em' }}
          isLoading={loadingCreateMacro}
        />
      </Styles.SubmitReply>
    </Styles.NewMacroStep4SC>
  );
};
export default NewMacroStep5;
